/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyright': 'Drevet af Atlassian Intelligence',
  'fabric.editor.ai.commandPalette.footer.atlassianIntelligenceCopyrightShort': 'Drevet af AI',
  'fabric.editor.ai.commandPalette.footer.disclaimerText':
    'Indholdet er baseret på dine tilladelser, og kvaliteten kan variere',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextShort': 'Indholdskvaliteten kan variere',
  'fabric.editor.ai.commandPalette.footer.disclaimerTextUpdated': 'Bruger kunstig intelligens. Bekræft resultater.',
  'fabric.editor.ai.commandPalette.footer.infoIconLabel': 'Information',
  'fabric.editor.ai.commandPalette.footer.rovoCopyright': 'Rovo',
  'fabric.editor.ai.commandPalette.footer.usePageKnowledgeToggleLabel': 'Medtag viden fra den aktuelle side',
  'fabric.editor.ai.commandPalette.promptForm.logo': 'Atlassian Intelligence-logo',
  'fabric.editor.ai.components.backIconButton.backLabel': 'Tilbage',
  'fabric.editor.ai.components.cancelEscButton.cancelLabel': 'Annuller',
  'fabric.editor.ai.components.cancelEscButton.escLabel': 'Esc',
  'fabric.editor.ai.components.cancelIconButton.cancelLabel': 'Annuller',
  'fabric.editor.ai.components.cancelIconButton.cancelTooltip': 'Annuller',
  'fabric.editor.ai.components.feedbackForm.badResponse': 'Dårligt svar',
  'fabric.editor.ai.components.feedbackForm.feedbackSent': 'Feedback sendt',
  'fabric.editor.ai.components.feedbackForm.goodResponse': 'Godt svar',
  'fabric.editor.ai.config.item.action.continueFromLatestResponse': 'Fortsæt fra sidste svar',
  'fabric.editor.ai.config.item.action.copyResponse': 'Kopiér',
  'fabric.editor.ai.config.item.action.responseCopied': 'Kopieret!',
  'fabric.editor.ai.config.item.action.responseCopiedToClipboard': 'Kopieret til udklipsholder',
  'fabric.editor.ai.config.item.action.retryPrompt': 'Prøv igen',
  'fabric.editor.ai.experience-application.documentInsertError':
    'Vi har problemer med at indsætte svaret. Luk dialogboksen, og prøv igen.',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    'Vi kunne ikke få et svar. Prompten eller svaret var over grænsen for denne anmodning. Luk dialogboksen, og prøv igen.',
  'fabric.editor.ai.experience.apiError': 'Vi kunne ikke få svar. Prøv igen.',
  'fabric.editor.ai.experience.commandPaletteAriaName': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.inputTooShortError':
    'Indholdet er for kort til at opsummere. Tilføj mere, og prøv igen.',
  'fabric.editor.ai.experience.loadingAriaTitle': 'Genererer',
  'fabric.editor.ai.experience.previewScreenLabel': 'Forhåndsvis',
  'fabric.editor.ai.experience.rovoAgents.agentPalette.placeholder':
    'Bed agenten om at skrive noget, eller vælg fra listen nedenfor',
  'fabric.editor.ai.experience.rovoAgents.productLabel': 'Rovo',
  'fabric.editor.ai.experience.rovoAgents.productLogoAltText': 'Rovo-logo',
  'fabric.editor.ai.screens.UserInputCommamdPalette.footerText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.discard.cancelLabel': 'Tilbage',
  'fabric.editor.ai.screens.discard.discardLabel': 'Kassér',
  'fabric.editor.ai.screens.error.warningIconLabel': 'Advarsel',
  'fabric.editor.ai.screens.error.ariaErrorTitle': 'Fejl',
  'fabric.editor.ai.screens.error.cancelLabel': 'Annuller',
  'fabric.editor.ai.screens.error.retryLabel': 'Prøv igen',
  'fabric.editor.ai.screens.loading.adfContentAriaLiveRegionDescription': 'Liveopdatering af indhold:',
  'fabric.editor.ai.screens.loading.iconAltText': 'Genererer ikon',
  'fabric.editor.ai.screens.preview.betaLabel': 'Beta',
  'fabric.editor.ai.screens.preview.cancelLabel': 'Annuller',
  'fabric.editor.ai.screens.preview.defaultAIPlaceholder': 'Fortæl AI, hvad der nu skal gøres',
  'fabric.editor.ai.screens.preview.discardLabel': 'Kassér',
  'fabric.editor.ai.screens.preview.disclaimer': 'Informationskvaliteten kan variere.',
  'fabric.editor.ai.screens.preview.disclaimerLink': 'Få at vide hvorfor',
  'fabric.editor.ai.screens.preview.header.clear.hover': 'Ryd',
  'fabric.editor.ai.screens.preview.header.edit': 'Rediger prompt',
  'fabric.editor.ai.screens.preview.header.edit.hover': 'Rediger',
  'fabric.editor.ai.screens.preview.placeholderWithAgent': 'Spørg {agentName}, hvad der skal gøres som det næste',
  'fabric.editor.ai.screens.preview.refineButton': 'Tilpas',
  'fabric.editor.ai.screens.preview.refineDropdown.refineButton': 'Tilpas',
  'fabric.editor.ai.screens.prompt.logoAltText': 'Atlassian Intelligence-logo',
  'fabric.editor.ai.screens.prompt.logoText': 'Atlassian Intelligence',
  'fabric.editor.ai.screens.prompt.submitLabel': 'Send',
  'fabric.editor.ai.screens.prompt.submitTooltip': 'Send til AI',
  'fabric.editor.ai.screens.promptWithSelectedOption.promptSelected': '{promptName} – valgt',
  'fabric.editor.ai.screens.promptWithSelectedOption.removeLabel': 'Fjern',
  'fabric.editor.ai.shared.aiProactiveButtonLabel': 'Forslag',
  'fabric.editor.ai.shared.aiUniversalDescriptor': 'Skriveassistent',
  'fabric.editor.ai.shared.aiUniversalLongCallToAction': 'Lad Atlassian Intelligence hjælpe dig med at skrive',
  'fabric.editor.ai.shared.aiUniversalShortCallToAction': 'Skriv',
  'fabric.editor.ai.shared.betaLabel': 'Beta',
  'fabric.editor.ai.shared.generateContent.aiButtonTitle': 'AI (Atlassian Intelligence)',
  'fabric.editor.ai.ui.components.suggestions.betaLozenge': 'BETA',
  'fabric.editor.ai.ui.components.suggestions.newLozenge': 'NY',
  'fabric.editor.ai.ui.components.suggestions.tellAILabel': 'Svar AI',
  'fabric.editor.ai.ui.components.suggestions.tellAgentLabel': 'Fortæl agent',
};
